/**
 * Espelho leve dos campos canônicos (mantido em sincronia com
 * apps/api/src/ingestion/canonical.ts). Usado nos dropdowns da tela de revisão.
 */
export interface CanonicalFieldUI {
  key: string;
  label: string;
  required: boolean;
}

export const CANONICAL_FIELDS_UI: CanonicalFieldUI[] = [
  { key: 'comprador.nome', label: 'Comprador · Nome', required: true },
  { key: 'comprador.contato_telefone', label: 'Comprador · Telefone', required: false },
  { key: 'comprador.contato_email', label: 'Comprador · E-mail', required: false },
  { key: 'comprador.documento', label: 'Comprador · Documento', required: false },
  { key: 'contrato.unidade', label: 'Contrato · Unidade', required: true },
  { key: 'contrato.valor_contrato', label: 'Contrato · Valor', required: true },
  { key: 'contrato.saldo_devedor', label: 'Contrato · Saldo devedor', required: false },
  { key: 'contrato.indice_correcao', label: 'Contrato · Índice de correção', required: false },
  { key: 'contrato.data_assinatura', label: 'Contrato · Data de assinatura', required: false },
  { key: 'contrato.data_base_reajuste', label: 'Contrato · Data-base do reajuste', required: false },
  { key: 'contrato.marco_obra', label: 'Contrato · Marco de obra', required: false },
  { key: 'contrato.status', label: 'Contrato · Status', required: false },
  { key: 'parcela.numero', label: 'Parcela · Número', required: false },
  { key: 'parcela.valor', label: 'Parcela · Valor', required: false },
  { key: 'parcela.vencimento', label: 'Parcela · Vencimento', required: false },
  { key: 'parcela.status_pagamento', label: 'Parcela · Status de pagamento', required: false },
];

export const REQUIRED_KEYS = CANONICAL_FIELDS_UI.filter((f) => f.required).map((f) => f.key);

export function labelFor(key: string | null): string {
  if (!key) return 'ignorar coluna';
  return CANONICAL_FIELDS_UI.find((f) => f.key === key)?.label ?? key;
}
